module.exports = __webpack_public_path__ + "media/images/facebook-e75f80c8.png";